import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useFacilitiesTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
